declare global {
  interface Window {
    fbq?: any
    _fbq?: any
    __MP_PIXEL_INITIALIZED__?: boolean
  }
}

const PIXEL_ID = '1607641457021236'

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return
  // Window-level guard — survives HMR / React StrictMode double-invokes
  if (window.__MP_PIXEL_INITIALIZED__) return
  window.__MP_PIXEL_INITIALIZED__ = true

  // Standard Meta Pixel base code
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // eslint-disable-next-line no-console
  console.log('[MetaPixel] Initialized + PageView tracked')
}

export const trackEvent = (event: string, params?: Record<string, any>) => {
  if (typeof window === 'undefined') {
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] window unavailable')
    return
  }
  if (!window.fbq) {
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] fbq not loaded yet — event lost:', event)
    return
  }
  if (params) {
    window.fbq('track', event, params)
  } else {
    window.fbq('track', event)
  }
  // eslint-disable-next-line no-console
  console.log('[MetaPixel] Tracked:', event, params || '')
}
